import { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Banner, BodyText, Button, Label, Link, Modal, Stack } from '@servicetitan/design-system';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { NotifyDevelopersStore } from '../stores/error-reporter.store';

const ReportForm: FC = observer(() => {
    const [store] = useDependencies(NotifyDevelopersStore);

    return (
        <Stack direction="column">
            <Label className="m-b-1">Error message</Label>
            <Banner icon title={store.errorInfo!.message} status="critical" className="m-b-4" />
            <BodyText>
                For further assistance, please contact Technical Support through the{' '}
                <Link href="//go.servicetitan.com/help-center" target="_blank" primary>
                    Help Center
                </Link>
                .
            </BodyText>
        </Stack>
    );
});

const ErrorReporterUnwrapped: FC = observer(() => {
    const [open, setOpen] = useState(false);
    const [store] = useDependencies(NotifyDevelopersStore);

    const toggleOpen = () => setOpen(!open);

    useEffect(() => {
        const listener = (event: Event) => {
            setOpen(true);
            store.setErrorInfo((event as CustomEvent).detail);
        };

        window.addEventListener('report_error', listener);

        return () => {
            window.removeEventListener('report_error', listener);
        };
    }, [store]);

    return (
        <Modal
            open={open}
            size={Modal.Sizes.M}
            title="Application Error"
            closable
            onClose={toggleOpen}
            footer={<Button onClick={toggleOpen}>Close</Button>}
        >
            <ReportForm />
        </Modal>
    );
});

export const ErrorReporter = provide({
    singletons: [NotifyDevelopersStore],
})(ErrorReporterUnwrapped);
